import React from "react";
import styles from "./Cell.module.scss";

const Cell = (props) => {
  const { className, children, tags, alert, detailView } = props;

  const outerClasses = [
    styles.module,
    alert ? styles.alert : null,
    detailView ? styles.detailView : null, // within window popup
  ]

  const classes = [
    styles.main,
    className,
  ]

  return (
    <div className={outerClasses.join(" ")}>
      <div className={classes.join(" ")}>
        { header(props) }
        { tagsLine(tags) }
        { children }
      </div>
      { alert && alertArea(alert) }
    </div>
  );
}

function header({ title, actions }) {
  const headerClasses = [
    styles.header,
  ]

  return (title || actions) && ( 
    <div className={headerClasses.join(" ")}>
      { title }
      { actions }
    </div>
  );
}

function tagsLine(tags) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return <div className={styles.tags}>{ tags }</div>;
}

function alertArea({ text, button }) {
  return (
    <div className={styles.alertArea}>
      { text }
      { button }
    </div>
  )
}

export default Cell;